(function() {
	window.konto = {};
}());
